import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import logo from '../assets/images/logo_with_text_lg.png';

const LandingPage: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <section className="flex flex-col items-center justify-center min-h-[70vh] text-center px-4 py-16 md:py-24 max-w-2xl mx-auto">
      <img src={logo} alt="HeartPort" className="h-20 md:h-28 w-auto mb-8" />

      <p className="text-lg md:text-xl text-[#111D4E]/70 mb-3 md:mb-4">
        {t('landing.subtitle')}
      </p>

      <p className="text-base md:text-lg text-[#111D4E]/70 max-w-prose mb-10 md:mb-12">
        {t('landing.partnerDescription', t('landing.description'))}
      </p>

      <div className="flex flex-col sm:flex-row gap-4">
        <button
          onClick={() => navigate('/login')}
          className="px-8 py-3 bg-[#47ABDB] text-white rounded-md font-semibold hover:bg-[#3d8fb8] transition-colors text-lg"
        >
          {t('landing.signIn')}
        </button>
        <button
          onClick={() => navigate('/signup')}
          className="px-8 py-3 border-2 border-[#47ABDB] text-[#47ABDB] rounded-md font-semibold hover:bg-[#47ABDB]/10 transition-colors text-lg"
        >
          {t('landing.signUp')}
        </button>
      </div>
    </section>
  );
};

export default LandingPage;
